import ButterImage from '../../components/ButterImage'
import { Product } from '../../types'
export type ProductHeroProps = {
  readonly products: ReadonlyArray<{
    readonly name: string
    readonly description: string
    readonly product: Product
    readonly image?: string
    readonly imageDescription: string
  }>
}

/**
 * This component renders a hero with a list of products.
 * @param products the list of products to render
 */
export default function ProductHero({ products }: ProductHeroProps) {
  return (
    <div style={{ display: 'flex', justifyContent: 'center' }}>
      {products
        .filter(({ product }) => 'meta' in product)
        .map(({ product, description, image, imageDescription, name }) => (
          <div key={product.id} data-shopify-product-id={product.id}>
            <ButterImage src={image} alt={imageDescription} width={300} height={300} />

            <h2>{name}</h2>

            <p>{description}</p>
          </div>
        ))}
    </div>
  )
}
